<template>
    <Loading :loading="loading" :inset="true" :text="$t('Resending E-Mail') + '...'">
        <form @submit.prevent="requestVerifyEmail()" class="relative">
            <FormButton type="submit" class="my-6" styling="primary flex items-center gap-3" :value="$t('resend_email')" :disabled="loading">
                <FontAwesomeIcon
                    v-show="loading"
                    :icon="['fas', 'circle-notch']"
                    class="animate-spin text-white transition-all ease-in-out duration-300 w-0"
                    :class="loading ? 'w-10' : ''"
                >
                </FontAwesomeIcon>
            </FormButton>
        </form>
    </Loading>
</template>

<script>
import api from '../../api';

export default {
    data: () => ({
        loading: false
    }),

    methods: {
        requestVerifyEmail() {
            this.loading = true;
            api.post('/email/verification-notification').then((response) => {
                this.$router.push('/');
                this.loading = false;
            });
        }
    }
};
</script>
